import * as React from "react";

import { Root } from "./NormativeHelpPageContainer.styles";

export interface NormativeHelpPageContainerProps {
    children: readonly React.ReactNode[];
}

export function NormativeHelpPageContainer(props: NormativeHelpPageContainerProps): JSX.Element {
    return <Root>{props.children}</Root>;
}
